// types
import type { AdditionalSelectors } from '@makemydeal/dr-activities-change-vehicle';
import * as chooseVehicleAppSelectors from '../../selectors/chooseVehicleAppSelectors';

export const additionalSelectors: AdditionalSelectors = {
    getCommonOrgId: chooseVehicleAppSelectors.getCommonOrgId,
    getDealerName: chooseVehicleAppSelectors.getDealerName,
    getDealId: chooseVehicleAppSelectors.getDealXgId,
    getServicesBff: chooseVehicleAppSelectors.getServicesBff,
    shouldShowCost: chooseVehicleAppSelectors.isCostVisible,
    getVehicleVin: chooseVehicleAppSelectors.getVehicleVin,
    getVehicleStockNumber: chooseVehicleAppSelectors.getStockNumber,
    getInitialSearchParameters: (state: any) => {
        const initialSearchValue = chooseVehicleAppSelectors.getInitialSearchValue(state) || '';
        return { search: initialSearchValue };
    },
    getDealerships: chooseVehicleAppSelectors.getDealerships,
    isEnableCrossDealershipAIVehicleSearch: chooseVehicleAppSelectors.isEnableCrossDealershipAIVehicleSearch,
    isAgeOfInventorySearchEnabled: chooseVehicleAppSelectors.isAgeOfInventorySearchEnabled,
    isPromptOptimizationEnabled: chooseVehicleAppSelectors.isPromptOptimizationEnabled,
    isSimilarityBodyStyleRelaxationEnabled: chooseVehicleAppSelectors.isSimilarityBodyStyleRelaxationEnabled,
    // AVO (section + Add New Scenario) is Manager View-only. Pin false explicitly so the host-scope
    // decision is visible here and survives F291824 toggle removal — do not rely on omission.
    isAiAltVehicleOptionsActive: () => false,
    isAiAltVehicleOptionsSectionVisible: () => false,
    // No scoped store outside Manager View, so a scenario cannot be created here.
    canCreateScenario: () => false
};
